import type { ReactNode } from 'react'
import { useSlate } from 'slate-react'
import MentionToolbarIcon from 'shared/icons/mention-toolbar-icon'
import { ToolbarButton } from '../../common/toolbar-button'
import { isMentionActive } from '../../utils/mention'

const MentionButton = ({ onClick }: { onClick: () => void }): ReactNode => {
  const editor = useSlate()
  const mentionActive = isMentionActive(editor)

  return (
    <ToolbarButton active={mentionActive} format="mention" onClick={onClick}>
      <MentionToolbarIcon className="size-5 text-text-secondary hover:text-[initial] md:size-6" />
    </ToolbarButton>
  )
}

export default MentionButton
